/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./createEditDialog.vue?vue&type=template&id=a70898c8"
import script from "./createEditDialog.vue?vue&type=script&lang=js"
export * from "./createEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports